var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"card p-6",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n    "+_vm._s(_vm.$route.meta)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }